export default {
  methods: {
    scrollToTop () {
      document.querySelector('body').scrollIntoView();
    },
    scrollToClass (className) {
      document.querySelector(`.${className}`).scrollIntoView();
    },
  }
}